import { render, staticRenderFns } from "./IndustrialPark.vue?vue&type=template&id=3914e81b&scoped=true&"
import script from "./IndustrialPark.vue?vue&type=script&lang=js&"
export * from "./IndustrialPark.vue?vue&type=script&lang=js&"
import style0 from "./IndustrialPark.vue?vue&type=style&index=0&id=3914e81b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3914e81b",
  null
  
)

export default component.exports